import { useWarrantyLogsModalStore } from '../../model/use-warranty-logs-modal.store';
import { warrantyLogContext } from '../../model/warranty-log-context';
import { SelectBranch } from '../select-branch/select-branch';
import { SelectWarrantyType } from '../select-warranty-type/select-warranty-type';
import styles from './styles.module.scss';
import { WarrantyLogInput, WarrantyWipInfo } from 'api-new/generated';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { useQueryResponse } from 'components/table/contexts/query-response';
import { useWarrantyLogMutation, useWarrantyWipInfoQuery } from 'entities/warranty';
import { useAuth } from 'features/auth/contexts/auth';
import { formatErrorMessage, QueryError } from 'features/shared/model';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from 'shared';

export const ModalBody = () => {
  const { closeCreateModal } = useWarrantyLogsModalStore();
  const { refetch } = useQueryResponse(warrantyLogContext);
  const [branch, setBranch] = useState<number>();
  const [wipNumber, setWipNumber] = useState<number>();
  const { currentUser } = useAuth();
  const [isEnableQuery, setEnableQuery] = useState(false);
  const [inputData, setInputDate] = useState<WarrantyLogInput>();
  const [data, setData] = useState<WarrantyWipInfo>();

  useEffect(() => {
    if (branch == undefined || branch != currentUser?.branchId) setBranch(currentUser?.branchId);
  }, [currentUser]);

  const { mutate, isLoading } = useWarrantyLogMutation({
    onSuccess: () => {
      toast.success('Successfully created!');
      refetch();
      closeCreateModal();
    },
    onError: (error: QueryError) => {
      const message = formatErrorMessage(error);
      toast.error(message);
      console.error(message);
    }
  });

  const { isFetching } = useWarrantyWipInfoQuery(
    {
      branchId: branch!,
      wipNo: wipNumber!
    },
    undefined,
    {
      enabled: isEnableQuery,
      onSettled: () => {
        setEnableQuery(false);
      },
      onSuccess: (data) => {
        setInputDate((prev) => ({ ...prev, soHeaderId: data?.soHeaderId }));
        setData(data);
      }
    }
  );

  const onChangeBranch = (val?: number) => {
    setBranch(val);
  };

  const onChangeWipNumber = (val?: string) => {
    const wipNo = Number(val);

    if (isNaN(wipNo)) setWipNumber(undefined);
    else setWipNumber(wipNo);
  };

  const onSave = () => {
    if (!data?.soHeaderId || !inputData) return;

    mutate({ ...inputData, notes: inputData?.notes ?? '' });
  };

  return (
    <div className={styles.container}>
      <div className="d-flex flex-nowrap gap-2 align-items-end">
        <div className="d-flex flex-nowrap gap-2 flex-fill">
          <div className="w-50">
            <label className="form-label">Branch</label>
            <SelectBranch branch={branch} onChange={onChangeBranch} placeholder="Branch" isClearable={false} />
          </div>
          <div className="flex-grow-3">
            <label className="form-label">WIP Number</label>
            <input
              type="number"
              className={clsx('form-control form-control-sm form-control-solid', styles.input)}
              value={wipNumber ?? ''}
              onChange={(e) => onChangeWipNumber(e.target.value)}
            />
          </div>
        </div>
        <div>
          <Button
            text="Look Up"
            size="sm"
            icon={<InlineSvg path="/media/icons/custom/lookup-again.svg" />}
            disabled={!wipNumber || isLoading}
            onClick={() => setEnableQuery(true)}
            isLoading={isFetching}
            additionalClass="text-nowrap"
          />
        </div>
      </div>

      <div className={clsx(!data ? 'd-none' : null)}>
        <div className={clsx(styles.resultContainer, 'mt-6')}>
          <InlineSvg path="/media/icons/custom/information-4.svg" />
          <div>
            Reg Number <span>{data?.regNo}</span> Found
          </div>
        </div>

        <div className={clsx('mt-6')}>
          <label className="form-label">Warranty Type</label>
          <SelectWarrantyType
            warrantyTypeIds={inputData?.warrantyTypeId == undefined ? [] : [inputData.warrantyTypeId]}
            onChange={(val) => setInputDate((prev) => ({ ...prev, warrantyTypeId: val?.[0] }))}
            placeholder="Warranty Type"
            isClearable={false}
            isMulti={false}
          />
        </div>

        <div className={clsx('mt-6')}>
          <label className="form-label">Notes</label>
          <textarea
            className="form-control form-control-solid border-0 pe-10 resize-none"
            rows={3}
            value={inputData?.notes ?? ''}
            onChange={(e) => setInputDate((prev) => ({ ...prev, notes: e.target.value }))}
          />
        </div>
      </div>

      <div className={clsx(styles.footer, 'mt-6')}>
        <Button text="Create" size="sm" disabled={data == undefined} isLoading={isLoading} onClick={onSave} />
        <Button text="Cancel" variant="light-primary" size="sm" onClick={() => closeCreateModal()} />
      </div>
    </div>
  );
};
